// API Service for MySQL Database Backend
// This service communicates with a backend API that uses MySQL database

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ncbe-backend.vercel.app/api';

export interface UserData {
  name: string;
  firstName: string;
  email: string;
  password: string; // Should be hashed on backend
  phone: string;
  language: string;
}

export const apiService = {
  // Register a new user
  async registerUser(userData: UserData): Promise<{ success: boolean; user?: any; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Registration error:', error);
      return { success: false, error: 'Network error occurred' };
    }
  },

  // Login user
  async loginUser(email: string, password: string): Promise<{ success: boolean; user?: any; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Network error occurred' };
    }
  },

  // Check if email exists
  async checkEmailExists(email: string): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}/check-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      return data.exists || false;
    } catch (error) {
      console.error('Email check error:', error);
      return false;
    }
  },

  // Get user data (requires authentication token in headers if your backend needs it)
  async getUserData(email: string): Promise<{ success: boolean; user?: any; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Get user data error:', error);
      return { success: false, error: 'Network error occurred' };
    }
  },

  // Update user data
  async updateUser(userData: Partial<UserData> & { email: string }): Promise<{ success: boolean; user?: any; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/update-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Update user error:', error);
      return { success: false, error: 'Network error occurred' };
    }
  },
};

